// extracted by mini-css-extract-plugin
export default {"body":"Test_body__kIIRv","icon":"Test_icon__MgluR","inner":"Test_inner__UfAHK","header":"Test_header__XsxxB","text":"Test_text__Wt73X","wrap":"Test_wrap__47c3a"};